import {React, useEffect, useState, useRef} from 'react';
import './GoogleMap.css';
import { Link } from 'react-router-dom';
import { createPortal } from 'react-dom';

const GoogleMapIframe = ({ city, height = 350 }) => {

	const iframeRef = useRef(null);
	const [mapSrc, setMapSrc] = useState('');
        const [openCounty, setOpenCounty] = useState(null);
        const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0, width: 220 });
        const countyButtonRefs = useRef({});

        const openCountyMenu = (county, event) => {
  const rect = event.currentTarget.getBoundingClientRect();

  setMenuPosition({
    top: rect.bottom + window.scrollY + 6,
    left: rect.left + window.scrollX,
    //width: Math.max(rect.width, 220),
    width: window.innerWidth <= 600 ? window.innerWidth - 100 : Math.max(rect.width, 220),
  });

  setOpenCounty(county);
};

const closeCountyMenu = () => {
  setOpenCounty(null);
};
  

	useEffect(() => {
		if (!city) return;

		const src = `https://www.google.com/maps?q=${encodeURIComponent(city)}&output=embed`;
		setMapSrc(src);

	}, [city]);

const countyData = [
  {
    county: 'Sarasota County',
    cities: [
        { name: 'Sarasota', path: '/tree_service_sarasota' },
        { name: 'Bee Ridge', path: '/tree_service_bee_ridge' },
	{ name: 'Fruitville', path: '/tree_service_fruitville' },
	{ name: 'The Meadows', path: '/tree_service_the_meadows' },
	{ name: 'Sarasota Springs', path: '/tree_service_sarasota_springs' },
	{ name: 'Kensington Park', path: '/tree_service_kensington_park' },
	{ name: 'Ridge Wood Heights', path: '/tree_service_ridge_wood_heights' },
        { name: 'Siesta Key', path: '/tree_service_siesta_key' },
        { name: 'Longboat Key', path: '/tree_service_longboat_key' },
	{ name: 'Lido Key', path: '/tree_service_lido_key' },
	{ name: 'Casey Key', path: '/tree_service_casey_key' },
        { name: 'Venice', path: '/tree_service_venice' },
	{ name: 'South Venice', path: '/tree_service_south_venice' },
	{ name: 'Nokomis', path: '/tree_service_nokomis' },
	{ name: 'Gulf Gate Estates', path: '/tree_service_gulf_gate_estates' },
        { name: 'Englewood', path: '/tree_service_englewood' },
        { name: 'Osprey', path: '/tree_service_osprey' },
        { name: 'Palmer Ranch', path: '/tree_service_palmer_ranch' },
        { name: 'North Port', path: '/tree_service_north_port' },
	{ name: 'Laurel', path: '/tree_service_laurel' },
	{ name: 'Vamo', path: '/tree_service_vamo' },
    ],
  },
  {
    county: 'Manatee County',
    cities: [
        { name: 'Bradenton', path: '/tree_service_bradenton' },
	{ name: 'Bradenton Beach', path: '/tree_service_bradenton_beach' },
	{ name: 'Holmes Beach', path: '/tree_service_holmes_beach' },
	{ name: 'Bayshore Gardens', path: '/tree_service_bayshore_gardens' },
	{ name: 'South Bradenton,', path: '/tree_service_south_bradenton' },
	{ name: 'Whitfield', path: '/tree_service_whitfield' },
	{ name: 'Whitfield Estates', path: '/tree_service_whitfield_estates' },
	{ name: 'Cortez', path: '/tree_service_cortez' },
	{ name: 'Myakka City,', path: '/tree_service_myakka_city' },
	{ name: 'Duette', path: '/tree_service_duette' },
	{ name: 'Tallevast', path: '/tree_service_tallevast' },
	{ name: 'Rubonia', path: '/tree_service_rubonia' },
	{ name: 'Samoset', path: '/tree_service_samoset' },
	{ name: 'Oneco,', path: '/tree_service_oneco' },
	{ name: 'Memphis', path: '/tree_service_memphis' },
        { name: 'West Bradenton', path: '/tree_service_bradenton' },
        { name: 'Palmetto', path: '/tree_service_palmetto' },
        { name: 'Parrish', path: '/tree_service_parrish' },
        { name: 'Lakewood Ranch', path: '/tree_service_lakewood_ranch' },
        { name: 'Ellenton', path: '/tree_service_ellenton' },
        { name: 'Anna Maria Island', path: '/tree_service_anna_maria' },
    ],
  },
  {
    county: 'Hillsborough County',
    cities: [
        { name: 'Tampa', path: '/tree_service_tampa' },
        { name: 'Riverview', path: '/tree_service_riverview' },
        { name: 'Ruskin', path: '/tree_service_ruskin' },
        { name: 'Brandon', path: '/tree_service_brandon' },
        { name: 'Apollo Beach', path: '/tree_service_apollo_beach' },
        { name: 'Sun City Center', path: '/tree_service_sun_city_center' },
	{ name: 'East Tampa', path: '/tree_service_east_tampa' },
	{ name: 'West Tampa', path: '/tree_service_west_tampa' },
	{ name: 'North Tampa', path: '/tree_service_north_tampa' },
	{ name: 'New Tampa', path: '/tree_service_new_tampa' },
	{ name: 'South Tampa', path: '/tree_service_south_tampa' },
	{ name: 'Downtown Tampa', path: '/tree_service_downtown_tampa' },
	{ name: 'Ybor City', path: '/tree_service_ybor_city' },
	{ name: 'Seminole Heights', path: '/tree_service_seminole_heights' },
	{ name: 'Hyde Park', path: '/tree_service_hyde_park' },
	{ name: 'Palma Ceia', path: '/tree_service_palma_ceia' },
	{ name: 'Carrollwood', path: '/tree_service_carrollwood' },
	{ name: 'Northdale', path: '/tree_service_northdale' },
	{ name: 'Lutz', path: '/tree_service_lutz' },
	{ name: 'Temple Terrace', path: '/tree_service_temple_terrace' },
	{ name: 'University', path: '/tree_service_university' },
	{ name: 'Town ‘n’ Country', path: '/tree_service_town_n_country' },
	{ name: 'Citrus Park', path: '/tree_service_citrus_park' },
	{ name: 'Westchase', path: '/tree_service_westchase' },
	{ name: 'Keystone', path: '/tree_service_keystone' },
	{ name: 'Egypt Lake-Leto', path: '/tree_service_egypt_lake_leto' },
	{ name: 'Valrico', path: '/tree_service_valrico' },
	{ name: 'Wimauma', path: '/tree_service_wimauma' },
	{ name: 'Gibsonton', path: '/tree_service_gibsonton' },
	{ name: 'Bloomingdale', path: '/tree_service_bloomingdale' },
	{ name: 'Progress Village', path: '/tree_service_progress_village' },
	{ name: 'Palm River-Clair Mel', path: '/tree_service_palm_river_clair_mel' },
	{ name: 'Seffner', path: '/tree_service_seffner' },
	{ name: 'Mango', path: '/tree_service_mango' },
	{ name: 'Fish Hawk', path: '/tree_service_fish_hawk' },
	{ name: 'Lithia', path: '/tree_service_lithia' },
	{ name: 'Balm', path: '/tree_service_balm' },
        { name: 'South Hillsborough', path: '/tree_service_south_hillsborough' },
    ],
  },
  {
    county: 'Pinellas County',
    cities: [
        { name: 'Saint Petersburg', path: '/tree_service_stpete' },
	{ name: 'Saint Petersburg Beach', path: '/tree_service_st_pete_beach' },
	{ name: 'Gulfport', path: '/tree_service_gulfport' },
	{ name: 'South Pasadena', path: '/tree_service_south_pasadena' },
	{ name: 'Treasure Island', path: '/tree_service_treasure_island' },
	{ name: 'Madeira Beach', path: '/tree_service_madeira_beach' },
	{ name: 'Redington Beach', path: '/tree_service_redington_beach' },
	{ name: 'North Redington Beach', path: '/tree_service_north_redington_beach' },
	{ name: 'Redington Shores', path: '/tree_service_redington_shores' },
	{ name: 'Indian Shores', path: '/tree_service_indian_shores' },
	{ name: 'Indian Rocks Beach', path: '/tree_service_indian_rocks_beach' },
	{ name: 'Belleair Beach', path: '/tree_service_belleair_beach' },
	{ name: 'Belleair Shore', path: '/tree_service_belleair_shore' },
        { name: 'Pinellas Park', path: '/tree_service_pinellas_park' },
        { name: 'Tierra Verde', path: '/tree_service_tierra_verde' },
        { name: 'Pass-a-Grille,', path: '/tree_service_pass_a_grille' },
        { name: 'Lealman', path: '/tree_service_lealman' },
	{ name: 'Bay Pines', path: '/tree_service_bay_pines' },
    ],
  },
  {
    county: 'Davis Islands',
    cities: [
        { name: 'Davis Islands', path: '/tree_service_davis_islands' },
        { name: 'Harbour Island', path: '/tree_service_harbour_island' },
        { name: 'Ballast Point', path: '/tree_service_ballast_point' },
	{ name: 'Port Tampa City', path: '/tree_service_port_tampa_city' },
	{ name: 'Sulphur Springs', path: '/tree_service_sulphur_springs' },
	{ name: 'Forest Hills', path: '/tree_service_forest_hills' },
	{ name: 'Lake Magdalene', path: '/tree_service_lake_magdalene' },
	{ name: 'Greater Carrollwood', path: '/tree_service_greater_carrollwood' },
	{ name: 'Temple Crest', path: '/tree_service_greater_carrollwood' },
	{ name: 'Lowry Park', path: '/tree_service_lowry_park' },
	{ name: 'Wellswood', path: '/tree_service_wellswood' },
	{ name: 'Palma Ceia West', path: '/tree_service_palma_ceia_west' },
	{ name: 'Virginia Park', path: '/tree_service_virginia_park' },
	{ name: 'Sunset Park', path: '/tree_service_sunset_park' },
    ],
  },
];

	return (
        <div id='main_mapDiv'>
            <div className='module_map1'>
                    <h1>Sam's Tree Service</h1>
                    <h2>Expert Tree Service Solutions Across {city}</h2>
                    <h2>Specializing in Dangerous Trees</h2>
                    {/*<h2>Proudly serving {city} and surrounding communities, including:</h2>
                     <h3><Link to="/tree_service_sarasota" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Sarasota</Link>, <Link to="/tree_service_bradenton" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Bradenton</Link>, <Link to="/tree_service_bradenton" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                West Bradenton</Link>, <Link to="/tree_service_siesta_key" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Siesta Key</Link>, <Link to="/tree_service_longboat_key" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Longboat Key</Link>, <Link to="/tree_service_lakewood_ranch" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Lakewood Ranch</Link>, <Link to="/tree_service_venice" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Venice</Link>, <Link to="/tree_service_englewood" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Englewood</Link>, <Link to="/tree_service_palmetto" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Palmetto</Link>, <Link to="/tree_service_parrish" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Parrish</Link>, <Link to="/tree_service_north_port" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                North Port</Link>, <Link to="/tree_service_punta_gorda" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Punta Gorda</Link>, <Link to="/tree_service_osprey" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Osprey</Link>, <Link to="/tree_service_palmer_ranch" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Palmer Ranch</Link>, <Link to="/tree_service_ruskin" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Ruskin</Link>, <Link to="/tree_service_stpete" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Saint Petersburg</Link>, <Link to="/tree_service_pinellas_park" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Pinellas Park</Link>, <Link to="/tree_service_riverview" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Riverview</Link>, <Link to="/tree_service_tampa" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Tampa</Link>, and surrounding areas.</h3>*/}
                                <div id='county_service_area'>
                                                                                
                                        <h3>We proudly serve</h3>

                                        <div id='county_dropdown_container'>
                                                {countyData.map((region) => (
                                                <div className='county_dropdown_item' key={region.county}>
                                                <button
                                                        type='button'
                                                        ref={(el) => {
                                                        countyButtonRefs.current[region.county] = el;
                                                        }}
                                                        className='county_label county_button'
                                                        onClick={(e) =>
                                                        openCounty === region.county? closeCountyMenu(): 
                                                                openCountyMenu(region.county, e)
                                                        }
                                                        aria-expanded={openCounty === region.county}
                                                        aria-haspopup='menu'
                                                        >
                                                        {region.county} <span className='county_caret'>▾</span>
                                                                </button>
                                                                </div>
                                                        ))}

                                                        <span id='county_suffix'>&nbsp;and surrounding areas.</span>
                                                        </div>
                                                </div>
                                                        {openCounty && createPortal(
                                                <div id='county-floating-menu' className='county_floating_menu'
                                                        style={{ top: `${menuPosition.top}px`, left: `${menuPosition.left}px`,
                                                                width: `${menuPosition.width}px`, }}>
                                                                {countyData.find((region) => region.county === openCounty)?.cities.map((city) => (
                                                                        <Link
                                                                        key={city.name}
                                                                        to={city.path}
                                                                        className='county_dropdown_link'
                                                                        onClick={() => {
                                                                        window.scrollTo(0, 0);
                                                                        closeCountyMenu();
                                                                        }}
                                                                        >
                                                                        {city.name}
                                                                        </Link>
                                                                        ))}
                                                                </div>, document.body)}      

                 <p>Whether you're in a bustling neighborhood or a quieter, more rural area, we're ready to bring our top-notch services right to your doorstep.</p>   

            </div>
            <div className='module_map2'>
                
		        <iframe
			        ref={iframeRef}
			        title={`Map of ${city}`}
			        src={mapSrc}
			        width="100%"
			        height='100%'//{height}
			        style={{ border: 0, borderRadius: '12px' }}
			        loading="lazy"
			        referrerPolicy="no-referrer-when-downgrade"
		        />
                </div>
        </div>
	);
};

export default GoogleMapIframe;
